import { render, staticRenderFns } from "./softwareLis.vue?vue&type=template&id=b6d45c6a&scoped=true&"
import script from "./softwareLis.vue?vue&type=script&lang=ts&"
export * from "./softwareLis.vue?vue&type=script&lang=ts&"
import style0 from "./softwareLis.vue?vue&type=style&index=0&id=b6d45c6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d45c6a",
  null
  
)

export default component.exports